// Initialize PRNG if environment provides CSPRNG.
// If not, methods calling randombytes will throw.
var QUOTE = 1 << 16;
export function _randomBytes(x, n) {
    for (var i = 0; i < n; i += QUOTE) {
        crypto.getRandomValues(x.subarray(i, i + Math.min(n - i, QUOTE)));
    }
}
//# sourceMappingURL=random.js.map